window.onjQueryLoad(function () {
    require('plugin_wishlists/product/tile');
}, true);
